export default __webpack_public_path__ + "static/media/mobilegame.c73c70cd.png";